<template>
  <Dialog :modelValue="modelValue" @update:modelValue="emit('update:modelValue', $event)" @close="emit('close')">
    <div class="dialog">
      <div class="dialog-title">
        <img :src="missionTitleImg" alt="missionTitle">
      </div>
      <div class="dialog-content-wrap">
        <div class="mission-list">
          <div v-for="task in tasks" :key="task.taskType" class="mission-item">
            <span class="mission-name">{{ taskName(task) }}</span>
            <span class="mission-reward">
              <img class="mission-icon" src="~@/views/act/halloween/assets/img/nangua-small.png" alt="">
              <span>+{{ task.strikeCount }}</span>
            </span>
            <button
              v-if="isShareTask(task)"
              type="button"
              class="mission-share"
              @click="emit('share')"
            >
              {{ t('halloween.share') }}
            </button>
            <button
              type="button"
              class="mission-btn"
              :class="statusClass(task)"
              :disabled="!canPlay || Number(task.status) !== 1"
              @click="emit('receive', task)"
            >
              {{ statusText(task) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from '../index.vue'
import MissionTitleMap from '@/views/act/halloween/assets/img/missionTitle'

const SHARE_TASK = 'hw_weekly_share'

const emit = defineEmits(['update:modelValue', 'close', 'share', 'receive'])
defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  tasks: {
    type: Array,
    default: () => [],
  },
  canPlay: {
    type: Boolean,
    default: false,
  },
})

const { t, te, locale } = useI18n()

const missionTitleImg = computed(() => MissionTitleMap[locale.value] || MissionTitleMap.en)

const taskName = (task) => {
  const key = `halloween.tasks.${task?.taskType}`
  const name = te(key) ? t(key) : task?.taskType
  const weekly = task?.isDaily === false || String(task?.taskType || '').includes('weekly')
  const cycle = t(weekly ? 'halloween.taskCycle.weekly' : 'halloween.taskCycle.daily')
  return `${name} (${cycle})`
}

const isShareTask = (task) => task?.taskType === SHARE_TASK

const statusText = (task) => {
  if (Number(task?.status) === 2) return t('halloween.missionClaimed')
  if (Number(task?.status) === 1) return t('halloween.missionCompleted')
  return t('halloween.missionIncomplete')
}

const statusClass = (task) => {
  if (Number(task?.status) === 2) return 'is-claimed'
  if (Number(task?.status) === 1) return 'is-completed'
  return 'is-incomplete'
}
</script>

<style scoped lang="less">
.dialog {
  overflow: hidden;

  .dialog-title {
    width: 424px;
    height: 77px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/views/act/halloween/assets/img/dialog-title-bg.png') no-repeat center center / 100% 100%;
    margin: 0 auto;
    margin-top: -10px;

    img {
      height: 65px;
      margin-top: 10px;
    }
  }

  .dialog-content-wrap {
    width: 608px;
    height: 396px;
    margin: 30px auto 0;
    padding: 18px 22px;
    box-sizing: border-box;
    background: url('~@/views/act/halloween/assets/img/dialog-inner-bg.png') no-repeat center center / 100% 100%;
  }
}

.mission-list {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mission-item {
  min-height: 72px;
  padding: 8px 14px 8px 18px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 5px;
  background: url('~@/views/act/halloween/assets/img/mission-item-bg.png') no-repeat center center / 100% 100%;
}

.mission-name {
  flex: 1;
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
}

.mission-reward {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  flex: none;
}

.mission-icon {
  width: 28px;
  height: 28px;
}

.mission-share {
  flex: none;
  height: 40px;
  padding: 0 5px;
  border: 0;
  background: #ffe94a;
  color: #1d4ed8;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.5px;
  cursor: pointer;
}

.mission-btn {
  flex: none;
  width: 132px;
  min-height: 40px;
  padding: 5px 2px;
  border: 0;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.5px;
  cursor: pointer;
  border: 1px solid #8C8C8C;

  &:disabled {
    cursor: default;
  }

  &.is-claimed {
    background: #9B9B9B;
    color: #fff;
  }

  &.is-completed {
    background: #ffe94a;
    color: #1d4ed8;
  }

  &.is-incomplete {
    background: #9B9B9B;
    color: #fff;
  }
}
</style>
